<template lang="pug">
    .component-parking-lot-controller
        .component-statistics-card.statistics-card-4(v-if="parkingGroup")
            .row
                .columns.small-6.large-4
                    .inner-content.card
                        span Parking Lot
                        h3 PL-{{item.id}} {{item.name}}
                .columns.small-6.large-4
                    .inner-content.card
                        span Parking Group
                        h3 PG-{{parkingGroup.id}} {{parkingGroup.name}}
                .columns.small-6.large-4
                    .inner-content.card
                        span Total Slots
                        h3 {{item.parking_slots.length}}
        loading-spinner(v-else)
        .row
            .columns
                router-tab-headers#vehicle-details(:tabs="tabs")
                    router-view
</template>

<script>
    import RouterTabHeaders from "components/structure/foundation/RouterTabHeaders";
    import Cards from "../../../components/structure/Cards"

    // to be moved
    import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
    import LoadingSpinner from "../../../components/structure/LoadingSpinner";

    export default {
        name: "ParkingLot",
        components: {
            LoadingSpinner,
            RouterTabHeaders,
            Cards,
        },
        props: ['item'],

        created() {

            KeplerBackofficeSdk.parkingGroups.list.all((data) => {

                data.forEach((pg) => {
                    pg.parking_lots.forEach((pl) => {
                        if (pl.id === this.item.id) {

                            this.parkingGroup = pg
                            this.bookingMode = pg.reservation_type
                        }
                    })

                })

            })

        },


        data: function () {
            return {
                tabs: [
                    {
                        headerName: 'Overview',
                        name: 'parkingLot',
                        pathName: 'parkingLot'
                    },
                    {
                        headerName: 'Manage',
                        name: 'manage',
                        pathName: 'manage'
                    },
                    {
                        headerName: 'Zones',
                        name: 'zones',
                        pathName: 'zones'
                    },
                ],
                bookingMode: null,
                parkingGroup: null
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParkingLot.vue?ae87eab6